// extracted by mini-css-extract-plugin
export default {"articles_container":"articles-management_articles_container__s3Paz","header_area":"articles-management_header_area__WvtYG","articles_tabs":"articles-management_articles_tabs__Otrfs"};